import { useCallback, useEffect, useMemo, useState } from 'react';
import { useUserContext } from '@/context';
import { MessageHttp } from '@/services';
import useRefresh from '../useRefresh';

export function useMessages() {
  const { isAuth } = useUserContext();
  const [refreshCounter, refresh] = useRefresh();
  const [loading, setLoading] = useState(false);
  const [messagesInbox, setInbox] = useState<InboxMessageEntity[]>([]);
  // const [messagesOutbox, setOutbox] = useState<MessageHttp.Message[]>([]);

  const fetch = useCallback(() => {
    setLoading(true);
    const promises = [];
    promises.push(
      MessageHttp.fetchInbox().then(res => {
        setInbox(res?.payload?.content ?? []);
      }),
      // MessageHttp.fetchOutbox().then(res => setOutbox(res?.payload?.content ?? [])),
    );
    Promise.all(promises).finally(() => setLoading(false));

  }, [setInbox, /* setOutbox */]);

  useEffect(() => {
    if (isAuth) {
      fetch();
    }
  }, [isAuth, refreshCounter]);

  const unreadForceMessages = useMemo(() => {
    return messagesInbox.filter(msg => msg.forceRead && !msg.read);
  }, [messagesInbox]);

  const markAsRead = useCallback(async (id: number | string) => {
    await MessageHttp.findById(id);
  }, []);

  return { refresh, loading, messagesInbox, markAsRead, unreadForceMessages };
}

export default useMessages;
